<template>
  <page>
    <template slot="content">
    <help-content :title="'1週間以上アプリを放置するとその前の歩数がなくなった'">
      <template slot="content">
        <div class="text">
          WeRUNアプリが<b>直近最大7日間のデータをスマホに保存</b>できます。長期間同期処理を行わない場合は日付の古い順番でデータが上書きされます。<br><br>
          データの紛失を防ぐために、<b>定期的にアプリを開き、同期処理を行う</b>ようにしてください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/8.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help32.vue